import AsyncPage from 'pages/AsyncPage'
import { loadDraft } from 'state/actions/drafts'

import universal from 'react-universal-component'

const EventPostPageUniversal = universal(props => import('events/ParticipantsAndSchedulerPages'))

export class AsyncEventPostPage extends AsyncPage {
  constructor() {
    super({
      title: 'compose.tag.page_title',
      pageComponent: EventPostPageUniversal
    })
    this.isModal = true
  }

  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      location: { payload  },
      draft: { value: post, error, upsertError: publishingError, loading }
    } = getState()
    const { postId, postType } = payload

    if (post || error || publishingError) {
      // this is the most likely case - user has moved on from the
      // composer by clicking "next", so the post is already loaded
      // in the `drafts` section of our application state or something
      // blew up when trying to publish
    } else {
      // user refreshed, or perhaps had a bookmark (!?) ...
      // load existing post from the API
      const draft = await loadDraft({ _id: postId, type: postType })(
        dispatch,
        getState,
        opts
      )
    }
  }
}

export const AsyncEventRolesPage = new AsyncEventPostPage()

export default new AsyncEventPostPage()